import { gql } from '@apollo/client';

// Invoice queries (reconciliation schema)
export const GET_INVOICES_QUERY = gql`
  query GetInvoices($studySiteInvestigatorId: UUID!, $status: String, $limit: Int = 100, $offset: Int = 0) {
    invoices(studySiteInvestigatorId: $studySiteInvestigatorId, status: $status, limit: $limit, offset: $offset) {
      edges {
        id
        invoiceNumber
        invoiceDate
        status
        totalMicros
        amountPaidMicros
        lineItemCount
        createdAt
      }
      totalCount
    }
  }
`;

export const GET_INVOICE_QUERY = gql`
  query GetInvoice($id: UUID!, $studyId: UUID!) {
    invoice(id: $id, studyId: $studyId) {
      id
      invoiceNumber
      invoiceDate
      dueDate
      status
      subtotalMicros
      taxMicros
      totalMicros
      amountPaidMicros
      siteOrganizationId
      sponsorOrganizationId
      studyId
      documentId
      supersededById
      createdAt
      lineItems {
        id
        lineNumber
        description
        quantity
        unitPriceMicros
        amountMicros
        activityLineItemId
      }
    }
  }
`;

// Invoice submissions query
export const GET_INVOICE_SUBMISSIONS_QUERY = gql`
  query GetInvoiceSubmissions($invoiceId: UUID!, $studyId: UUID!) {
    invoiceSubmissions(invoiceId: $invoiceId, studyId: $studyId) {
      id
      invoiceId
      submissionNumber
      submittedAt
      submittedToEmail
      responseStatus
      responseReceivedAt
      declineReasons
      notes
      createdAt
    }
  }
`;

// Invoice communications query (collections actions filtered by invoiceId)
export const GET_INVOICE_COMMUNICATIONS_QUERY = gql`
  query GetInvoiceCommunications($invoiceId: UUID!, $limit: Int = 50) {
    collectionsActions(invoiceId: $invoiceId, limit: $limit) {
      edges {
        id
        actionType
        recipientEmail
        senderEmail
        subject
        completedAt
        status
        externalReference
        createdAt
      }
      totalCount
    }
  }
`;

// Unbilled activities query (for invoice generation)
export const GET_UNBILLED_ACTIVITIES_QUERY = gql`
  query GetUnbilledActivities($studySiteInvestigatorId: UUID!) {
    unbilledActivities(studySiteInvestigatorId: $studySiteInvestigatorId) {
      activityLineItemId
      activityId
      patientNumber
      patientId
      activityName
      serviceDate
      amountMicros
      description
    }
  }
`;
